export var DEPLOY_DATE = new Date('2026-04-17T10:29:13+0000');
